import { Col, Container, Row, Image } from "react-bootstrap";
import logoImg from "../assets/img/portfolio-logo.png";

export const Footer = ({ contentData }) => {
    return (
        <div className="footer-container bg-dark text-light py-4">
            <Container>
                <Row>
                    <Col className="d-flex flex-column-reverse flex-lg-row justify-content-lg-between align-items-center">
                        <div className="text-center">
                            <Image className='logo' src={logoImg} style={{ width: "3rem" }} /> Copyright &copy; 2023. All rights are reserved.
                        </div>
                        <div>
                            {
                                contentData.socialLinks.map((link, index) => (
                                    <a className='social-icons' href={link.url} key={index}><i className={link.className}></i></a>
                                ))
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}